import "../scss/main.scss"

import React from "react"
import {useTranslation} from "react-i18next";
import {useKeycloak} from "@react-keycloak/web";


const ContactAdministratorError = () => {
  const {t} = useTranslation();
  let keycloak = useKeycloak();

  return (
    <div className="error-container">
      <h4 className="message">{t("account_error")}</h4>
      <h4 className="message">{t("please_contact_admin")}</h4>
      <a onClick={() => keycloak.keycloak.logout({
        redirectUri: "/"
      })}>{t("logout")}</a>
    </div>
  )
}

export default ContactAdministratorError;

